import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowExpand = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.375,9.966l7.581,-7.581",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.64px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.032,9.722l0,-7.505l-7.413,-0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.64px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.968,14.278l0,7.505l7.413,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.64px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.624,14.034l-7.581,7.581",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.64px"
				}
			})
		]
	})
});
export default SvgArrowExpand;
